/* unplugin-vue-components disabled */import { render } from "./StreetSettingView.vue?vue&type=template&id=bb85b974&scoped=true"
import script from "./StreetSettingView.vue?vue&type=script&lang=js"
export * from "./StreetSettingView.vue?vue&type=script&lang=js"

import "./StreetSettingView.vue?vue&type=style&index=0&id=bb85b974&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb85b974"]])

export default __exports__